import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close-img",
  "use": "icon-close-img-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-close-img\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill-opacity=\".5\" fill=\"#000\" cx=\"14\" cy=\"14\" r=\"14\" /><path d=\"M8 19.759L19.878 8m-11.696.063l11.467 11.584\" stroke=\"#FFF\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol